import { tGeneric, TLocGeneric } from '../services/translation/translationUtils.js';
import libraryInstance from './i18n.js';

var t = function t(key, options, interpolationOptions) {
  return tGeneric(key, options, interpolationOptions, libraryInstance);
};
var tLoc = function tLoc(key, options, interpolationOptions) {
  return TLocGeneric(key, options, interpolationOptions, libraryInstance);
};

export { t, tLoc };
